/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCESS_NUMBER: 'N.º de accesos',
    BLACK_FRIDAY_COMISSION_TITLE: 'Comisiones black friday {0}',
    BLACK_FRIDAY_COMMISSION: 'Comisiones del Viernes Negro {0}',
    BLACK_FRIDAY_COMMISSION_PREVIOUS: 'Comisiones del Viernes Negro {0}',
    COMISSION_DESCRIPTION: 'Total del mes actual:',
    COMISSION_LAST_MONTH: 'Homólogo',
    COMISSION_LAST_TEN: 'Últimos {0} días:',
    COMISSION_TITLE: 'Comisiones de los últimos {0} días:',
    COMMISSION: 'Comisiones',
    COMMISSION_COLUMN: 'Comisiones (€)',
    DAILY: 'Diariamente',
    DATE: 'Fecha',
    FEMALE: 'Mujer',
    FIFTY_DAYS: '50 días',
    GENDER: 'Género',
    HITS: 'Accesos en los últimos {0} días:',
    HITS_DESCRIPTION: 'Accesos',
    HOMOLOGOUS: 'Homólogo',
    HOMOLOGOUS_LAST_YEAR: 'Último año',
    MALE: 'Hombre',
    NAME: 'Nombre',
    NEW_CUSTOMERS: 'Nuevas cuentas de clientes {0} dias:',
    NEW_CUSTOMERS_ANNIVERSARY: 'Nuevas cuentas de clientes aniversario Prozis',
    NEW_CUSTOMERS_DETAIL_DESCRIPTION:
      'Nuevas cuentas pendientes de pedido {0} dias:',
    NO_SALES: 'No existen ventas',
    ORDER_PENDING_CUSTOMERS: 'Orden pendiente de cuenta',
    ORDERED_CUSTOMERS: 'Nueva cuenta de cliente',
    ORDERS: 'Pedidos en los últimos {0} días:',
    ORDERS_DESCRIPTION: 'Pedidos pagados en los últimos 6 meses',
    ORDERS_DETAIL_DESCRIPTION:
      'Pedidos pendientes de pago en los últimos {0} días:',
    ORDERS_PAY: 'Pedidos pagados',
    ORDERS_PENDING: 'Pedidos pendientes',
    PERCENTAGE: 'Porcentaje',
    PRODUCT_CATEGORY: 'Categoría',
    PRODUCT_COLUMN: 'Producto',
    QT_COLUMN: 'Cantidad',
    QUANTITY: 'Cantidad',
    SALES: 'Ventas',
    SALES_DESCRIPTION: 'Mes actual',
    SALES_PRODUCT: 'Ventas por categorías de productos',
    TEN_DAYS: '10 días',
    THIRTEEN_DAYS: '30 días',
    TOP_COMMISSION_TITLE:
      'Productos más lucrativos/que han generado más comisiones',
    TOP_DESCRIPTION: 'Mes actual',
    TOP_GENDER_DESCRIPTION: 'Últimos {0} días',
    TOP_GENDER_TITLE: 'Más vendidos por género',
    TOP_TITLE: 'Productos más vendidos',
    TWENTY_DAYS: '20 días',
    UPDATED_AT: 'Actualizado el {0}',
    VALUE: 'Importe'
  },
  SENTENCE: {
    EMPTY_DESCRIPTION: 'Faltan datos',
    EMPTY_TITLE: 'No hay datos'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
